import { Box, IconButton } from "@mui/material"
import { NavigateBackIcon, NavigateNextIcon } from "@tc/ui-dfe/icons"

export interface TablePaginationActionsProps {
  count: number
  page: number
  rowsPerPage: number
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number,
  ) => void
}

export const TablePaginationActions = (props: TablePaginationActionsProps) => {
  const { count, page, rowsPerPage, onPageChange } = props
  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page) // this is because mobile pagination start from 0, web pagination start from 1
  }

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    onPageChange(event, page + 2) // this is because mobile pagination start from 0, web pagination start from 1
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page <= 0}
        aria-label="previous page"
      >
        <NavigateBackIcon />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        data-testid="test-mobile-pagination-next"
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <NavigateNextIcon />
      </IconButton>
    </Box>
  )
}
